import React, { Component } from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import FooterPage from "../partials/footerPage";
import {
  Button
} from 'react-bootstrap';
import Cookies from "universal-cookie";
const cookies = new Cookies();


class Customer extends Component {
  render() {

    if (!this.props.data.page) {
      return <p>...</p>;
    }

const urlParams = new URLSearchParams(window.location.search);
const sessionId = urlParams.get("session_id")
   // let customerId;
    

const ManageButton = ({
    handleClick
  }) => (
     <Button className = "SubmitButton"
            target = "_blank"  
    onClick = {
      (e) => {
        handleClick(e);
      }
    }>
              {
          cookies.get("lang") === "LV" ? this.props.data.page.campaign.manageBillingLv : cookies.get("lang") === "EN" ? this.props.data.page.campaign.manageBillingEn : null
                }</Button>
);

if (sessionId) {
  fetch("https://checkout.kanepes.lv/checkout-session?sessionId=" + sessionId)
    .then(function (result) {
      return result.json()
    })
    .then(function (session) {
      // We store the customer ID here so that we can pass to the
      // server and redirect to customer portal. Note that, in practice
      // this ID should be stored in your database when you receive
      // the checkout.session.completed event. This demo does not have
      // a database, so this is the workaround. This is *not* secure.
      // You should use the Stripe Customer ID from the authenticated
      // user on the server.
    //  customerId = session.customer;

      //var sessionJSON = JSON.stringify(session, null, 2);
      //document.querySelector("pre").textContent = sessionJSON;
    })
    .catch(function (err) {
      console.log('Error when fetching Checkout session', err);
    });
  
  
const handleClick = async (e) => {
  e.preventDefault();
  //console.log("uasdsa");
  fetch('https://checkout.kanepes.lv/customer-portal', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        sessionId: sessionId
      }),
    })
    .then((response) => response.json())
    .then((data) => {
      console.log('handleClick');
      window.location.href = data.url;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  };



    //console.log(this.props.data.page);
    return (
      <React.Fragment>
        <div>
        <div id="singleManageCustomer" className="singlePage text-center"
        title={
          cookies.get("lang") === "LV" ? this.props.data.page.campaign.manageBillingLv : cookies.get("lang") === "EN" ? this.props.data.page.campaign.manageBillingEn : null
        }>
        <div className="container single-content-text">
        <h2>{
          cookies.get("lang") === "LV" ? this.props.data.page.campaign.successTitleLv : cookies.get("lang") === "EN" ? this.props.data.page.campaign.successTitleEn : null
              }</h2>
          
            <form id="manage-billing-form">
        <ManageButton handleClick = {
          handleClick.bind(this)
        } />
            </form>   
        </div>
        </div>
          <FooterPage />
        </div>
      </React.Fragment>
    );
  }

}
}

const GetCustomerBySlug = gql`
  query customer {
    page(id: "cG9zdDoxMDAw=") {
      campaign {
        successTitleEn
        successTitleLv
        manageBillingLv
        manageBillingEn
      }
    }
  }
`;

export default graphql(GetCustomerBySlug)(Customer);
